import angular from 'angular';

const name = 'mmsValidateUserEmail';
export const ValidateUserEmailDirective = {
    name,
    directive: directive
};

function directive($q, DataApiService) {
    'ngInject';
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attr, ctrl) {
            ctrl.$asyncValidators.validateUserEmail = function(modelValue, viewValue){
                const email = viewValue;
                if (!email) return $q.reject();

                return DataApiService.validateNewUser({email}).then(function(result){
                    return result? $q.resolve() : $q.reject();
                })
            };
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/directives/validateUserEmail.directive.js